import classNames from 'classnames';

import { Box } from 'ui/box';

import EmptySpaceContent from 'components/partials/empty-space-content/empty-space-content';

import Icons from 'assets/icons';

export interface MonitoringEmptyStateProps {
  text: string;
  className?: string;
  isError?: boolean;
}

const ERROR_IMAGE = (
  <Icons.Caution className="size-16 mb-2" aria-hidden="true" />
);

const MonitoringEmptyState = ({
  text,
  className,
  isError = false,
}: MonitoringEmptyStateProps) => (
  <Box
    role="status"
    aria-live="polite"
    sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 0%' }}
  >
    <EmptySpaceContent
      customClass={classNames('flex-1', className)}
      text={text}
      {...(isError && { image: ERROR_IMAGE })}
    />
  </Box>
);

export default MonitoringEmptyState;
